import { c as _c } from "react/compiler-runtime";
import React from 'react';
export interface FieldsetProps {
  children?: React.ReactNode;
  className?: string;
  id?: string;
  header?: string;
}
export const Fieldset: React.FC<FieldsetProps> = t0 => {
  const $ = _c(9);
  const {
    children,
    className,
    id,
    header
  } = t0;
  let t1;
  if ($[0] !== header) {
    t1 = header && <legend className="mb-comfy-xl mt-comfy-xl heading-sm">{header}</legend>;
    $[0] = header;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <div className="flex flex-col gap-comfy-sm">{children}</div>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== className || $[5] !== id || $[6] !== t1 || $[7] !== t2) {
    t3 = <fieldset id={id} className={className}>{t1}{t2}</fieldset>;
    $[4] = className;
    $[5] = id;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};